import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoffeeMachine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "coffee-machine" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M22.5,21.75a1.5,1.5,0,0,0-1.5-1.5H3a1.5,1.5,0,0,0,0,3H21A1.5,1.5,0,0,0,22.5,21.75Z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-1",
			points: "21 20.25 3 20.25 3 6.75 12 6.75 21 6.75 21 20.25"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 10.5,
			y1: 9.75,
			x2: 10.5,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 13.5,
			y1: 9.75,
			x2: 13.5,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.75,14.25c0,2.071,0,5.25-3.75,5.25-3,0-3.216-2.695-3.632-4.313A.751.751,0,0,1,9.1,14.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.75,14.25h0A2.25,2.25,0,0,1,18,16.5h0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 1.5,
			y: .75,
			width: 21,
			height: 6,
			rx: 1,
			ry: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-1",
			x: 9,
			y: 6.75,
			width: 6,
			height: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M19.125,3a.375.375,0,1,1-.375.375A.375.375,0,0,1,19.125,3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15.375,3A.375.375,0,1,1,15,3.375.375.375,0,0,1,15.375,3"
		})
	]
});
export default SvgCoffeeMachine;
